import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Icon from "../../Assets/Icons/ART_Icon_Download";
import { Link } from "react-router-dom";
import "../../Assets/Css/App.css";
import { YoutubePlayer } from "reactjs-media";
import Capacitacion_Evaluacion from "./Capacitacion_Evaluacion";
import Capacitacion_DDJJ from './Capacitacion_DDJJ';
import Api from '../../Api/Api';
import Denuncia from '../../Assets/Img/DENUNCIA.jpg';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {Button} from '@material-ui/core';
import Capacitacion_Certificado_PDF_Ventana from './Capacitacion_Certificado_PDF_Ventana.js';




function TabPanel(props) {
  const { children, value, index, ...other } = props;
  console.log('todo el show:',children, value, index)
  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {index == 11 ? value === index && <Box p={3} style={{padding: 0}}>{children}</Box> : value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  console.log('index: '+index)
  return {
      id: `full-width-tab-${index}`,
      'aria-controls': `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: 'auto',
    //width: 500,
  },
}));

const useStylesTab = makeStyles(theme => ({
  root: {
    'font-size': 'unset',
    'font-weight': 'bold',
     'width': 'auto',
    "& .MuiTabs-scroller ": {
      'white-space': 'initial',
    },
    "& .MuiTabs-flexContainer ": {
      'flex-wrap': 'wrap',
      'flex-direction': 'column',
    }
  },
  rootRiesgosTrabajo: {
    'font-size': 'unset',
    'font-weight': 'bold',
     'width': 'auto',
    "& .MuiTabs-scroller ": {
      'white-space': 'initial',
    },
    "& .MuiTabs-flexContainer ": {
      'flex-wrap': 'wrap',
      'flex-direction': 'row',
    }
  },
}));

export default function FullWidthTabs(props) {

  const classes = useStyles();
  const classesTab = useStylesTab();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const [nota, setNota] = React.useState(0);
  const [nota2, setNota2] = React.useState(0);
  const [notasDelUsuario,setNotasDelUsuario] = useState([null])
  const [notaDelUsuario,setNotaDelUsuario] = useState(0)
  const [accesoModuloRiesgoTrabajo2,setAccesoModuloRiesgoTrabajo2] = useState(true)
  const [accesoModuloRiesgoTrabajo3,setAccesoModuloRiesgoTrabajo3] = useState(true)
  const [verCertificado,setVerCertificado] = useState(false)
  const [abrirPDF,setAbrirPDF] = useState(false)
  

  const [enviaEvaluacion,setEnviaEvaluacion] = useState(true)
  const [expanded, setExpanded] = React.useState(false);

  const userCUIT = props.userCUIT2;
  const userId2  = props.userId;
  const userTipo2= props.userTipo;
  const establecimId= props.estabId;

  useEffect(() => { //se comporta como el ComponentDidMount     

    console.log('todo el prop:',props)
    if (props.userTipo == "T"){
    async function consultarTodasLasNotas (){
        
      try {
          const response = await Api.get(`CapacitacionesUsuarios/ListarPorEmpresaUsuario?pCUIT=${props.userCUIT2}&pUsuariosWebId=${props.userId}`, {
              headers: {
                  'Content-Type': 'application/json',
              }            
          })
          setNotasDelUsuario(response.data)
          
          //MAPACA
          response.data.map(calificaciones => {            
              if (calificaciones.CapacitacionesId == 1) {
                setNota(calificaciones.Calificacion);
              }
              
              if (calificaciones.CapacitacionesId == 2) {
                setNota2(calificaciones.Calificacion);
              }
          })

          const etapa1 = response.data.find(evaluacion => evaluacion?.CapacitacionesId == 15) ?? 0;
          const etapa2 = response.data.find(evaluacion => evaluacion?.CapacitacionesId == 16) ?? 0;
          const etapa3 = response.data.find(evaluacion => evaluacion?.CapacitacionesId == 17) ?? 0;
          setAccesoModuloRiesgoTrabajo2(etapa1.Calificacion > 5 ? false : true);
          setAccesoModuloRiesgoTrabajo3(etapa2.Calificacion > 5 ? false : true);
          setVerCertificado(etapa3.Calificacion > 5 ? true : false);
      }
      catch (error) {
          console.log('[nota error]: ' + error);
      } 
      return 0
    };

    consultarTodasLasNotas ()
    console.log('Cap_Usuario - UseEffect');

    }
  },[]);

  //window.scrollTo({ top: 200, behavior: 'smooth' })

  const consultarNota = (IdCapa,Index) => {
    handleChangeIndex(Index);
    const nota = notasDelUsuario.find(evaluacion => evaluacion?.CapacitacionesId == IdCapa) ?? 0;
    console.log('**nota**',nota);
    setNotaDelUsuario(nota ? nota.Calificacion : 0);
  }

  const reset = (parte) =>{
    
    parte == 15 && setAccesoModuloRiesgoTrabajo2(false);
    parte == 16 && setAccesoModuloRiesgoTrabajo3(false);
    
  }

  const handleChange = (event, newValue) => {
  console.log('newValue',newValue)
    setValue(newValue);
  };

  const handleChangeIndex = index => {
    setValue(index);
  };

  const state = {
    Mod1_Cap1:[
      {
        Desc:"Tipos",
        File: "EXPOSICION_RUV_01.jpg"
      },
      {
        Desc:"Daños por la Exposición",
        File: "EXPOSICION_RUV_02.jpg"
      },
      {
        Desc:"Estrategias Preventivas",
        File: "EXPOSICION_RUV_03.jpg"
      }
    ],

    Mod1_Cap2:[
      {
        Desc:"Proximamente",
        File: ""
      }
    ],

    Mod1_Cap3:[
      {
        Desc:"Proximamente",
        File: ""
      }
    ],
    
    
    Mod1_Cap4:[
      {
        Desc:"Proximamente",
        File: ""
      }
    ],

    Mod2_Cap1:[
      {
        Desc:"Condiciones Ingreso y Permanencia",
        File: "Condiciones Ingreso y Permanencia.pdf"
      },
      {
        Desc:"Prevención en el Lugar de Trabajo",
        File: "Prevención en el Lugar de Trabajo.pdf"
      },
      {
        Desc:"Síntomas",
        File: "Síntomas.pdf"
      }
    ],

    Mod2_Cap2: [
      {
        Desc:"Proximamente",
        File: ""
      }
    ],

    Mod2_Cap3: [
      {
        Desc:"Proximamente",
        File: ""
      }
    ],
  
    Mod2_Cap4: [
      {
        Desc:"Proximamente",
        File: ""
      }
    ],
  
    Mod2_Cap5: [
      {
        Desc:"Proximamente",
        File: ""
      }
    ],
  
    Mod3_Cap1:[
      {
        Desc:"Proximamente",
        File: ""
      }
    ],

    Mod3_Cap2:[
      {
        Desc:"Proximamente",
        File: ""
      }
    ],

    Mod4_Cap1:[
      {
        Desc:"Proximamente",
        File: ""
      }
    ],
  };

  const handleChangeAcc = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleAbrirPDF = () => {
    setAbrirPDF(!abrirPDF);
  }
  

  return (
    <div>
    <div className={classes.root} style={{display: 'flex'}}>
      <AppBar  position="static"  style={{'height': 'max-content',  width: 'auto',backgroundColor: 'white', color: 'grey', 'display': 'flex', flexFlow: 'column'}}>
          <Tab className="Mui-selected" style={{backgroundColor: '#83BC00', color: 'white', minWidth: '-webkit-fill-available'}} label="Capacitación Disposición SRT 2/2021"/>
          
          <Accordion expanded={expanded === 'panel1'} onChange={handleChangeAcc('panel1')}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
            <Tab className="Mui-selected" style={{backgroundColor: '#83BC00', color: 'white', textAlign: 'left', minWidth: '-webkit-fill-available'}} label="Modulo 1: Riesgos  en los Establecimientos"/>
            </AccordionSummary>
            <AccordionDetails>
            <AppBar  position="static"  style={{'height': 'max-content',  width: 'auto',backgroundColor: 'white', color: 'grey', 'display': 'flex', flexFlow: 'column'}}>
              <Tabs 
                    className={classesTab.root}
                    value={value-2}
                    onChange={handleChange}
                    TabIndicatorProps={{style: {background:'#83BC00', height:'5px'}}}
                    style={{backgroundColor: 'white', color: 'grey', 'display': 'flex', flexFlow: 'column'}}
                  >
                  <Tab className={classesTab.root} label="Radiaciones UltraVioletas" onClick={()=>consultarNota(4,2)} /> 
                  <Tab className={classesTab.root} label="Manipulación Manual de Cargas"  onClick={()=>consultarNota(7,3)} />
                  <Tab className={classesTab.root} label="Uso Seguro de la Motosierra" onClick={()=>consultarNota(9,4)}/>     
                  <Tab className={classesTab.root} label="Seguridad en la Oficina"  onClick={()=>consultarNota(12,5)} />       
              </Tabs>
              </AppBar>
            </AccordionDetails>
          </Accordion>

          <Accordion expanded={expanded === 'panel2'} onChange={handleChangeAcc('panel2')}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
          <Tab className="Mui-selected" style={{backgroundColor: '#83BC00', color: 'white', textAlign: 'left', minWidth: '-webkit-fill-available'}} label="Modulo 2: Normativa en Higiene y Seguridad en el Trabajo"/>
          </AccordionSummary>
            <AccordionDetails>
            <AppBar  position="static"  style={{'height': 'max-content',  width: 'auto',backgroundColor: 'white', color: 'grey', 'display': 'flex', flexFlow: 'column'}}>
              <Tabs 
                    className={classesTab.root}
                    value={value-7}
                    onChange={handleChange}
                    TabIndicatorProps={{style: {background:'#83BC00', height:'5px'}}}
                    style={{backgroundColor: 'white', color: 'grey', 'display': 'flex', flexFlow: 'column'}}
                  >
                <Tab className={classesTab.root} label="Capacitacion COVID-19" onClick={()=>consultarNota(1,7)}/>
                <Tab className={classesTab.root} label="Botiquin de primeros auxilios" onClick={()=>consultarNota(2,8)} />
                <Tab className={classesTab.root} label="Obstrucción de la vía aérea"  onClick={()=>consultarNota(5,9)}/>
                <Tab className={classesTab.root} label="Fracturas - Primeros auxilios" onClick={()=>consultarNota(10,10)} />
                <Tab className={classesTab.root} label="RCP en adultos, niños y bebés" onClick={()=>consultarNota(14,11)} />
              </Tabs>
              </AppBar>
            </AccordionDetails>
          </Accordion>
          
          
          <Accordion expanded={expanded === 'panel3'} onChange={handleChangeAcc('panel3')}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
            <Tab className="Mui-selected" style={{backgroundColor: '#83BC00', color: 'white', textAlign: 'left', minWidth: '-webkit-fill-available'}} label="Modulo 3: Elementos de Protección Personal"/>
            </AccordionSummary>
            <AccordionDetails>
            <AppBar  position="static"  style={{'height': 'max-content',  width: 'auto',backgroundColor: 'white', color: 'grey', 'display': 'flex', flexFlow: 'column'}}>
              <Tabs 
                    className={classesTab.root}
                    value={value-13}
                    onChange={handleChange}
                    TabIndicatorProps={{style: {background:'#83BC00', height:'5px'}}}
                    style={{backgroundColor: 'white', color: 'grey', 'display': 'flex', flexFlow: 'column'}}
                  >
                <Tab className={classesTab.root} label="EPP Generalidades"  onClick={()=>consultarNota(6,13)}/>
                <Tab className={classesTab.root} label="Uso de EPP para la aplicación de fitosanitarios"  onClick={()=>consultarNota(8,14)}/>
                </Tabs>
              </AppBar>
            </AccordionDetails>
          </Accordion>
          
          <Accordion expanded={expanded === 'panel4'} onChange={handleChangeAcc('panel4')}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
          <Tab className="Mui-selected" style={{backgroundColor: '#83BC00', color: 'white', textAlign: 'left', minWidth: '-webkit-fill-available'}} label="Modulo 4: Productos Químicos y Biológicos"/>
          </AccordionSummary>
          <AccordionDetails>
            <AppBar  position="static"  style={{'height': 'max-content',  width: 'auto',backgroundColor: 'white', color: 'grey', 'display': 'flex', flexFlow: 'column'}}>
              <Tabs 
                    className={classesTab.root}
                    value={value-16}
                    onChange={handleChange}
                    TabIndicatorProps={{style: {background:'#83BC00', height:'5px'}}}
                    style={{backgroundColor: 'white', color: 'grey', 'display': 'flex', flexFlow: 'column'}}
                  >
                  <Tab className={classesTab.root} label="Transporte Terrestre de Fitosanitarios" onClick={()=>consultarNota(3,16)}/>
                  <Tab className={classesTab.root} label="Preparación y Carga de Fitosanitarios en Mochila" onClick={()=>consultarNota(11,17)}/>
                  <Tab className={classesTab.root} label="Almacenamiento y depósito de fitosanitarios" onClick={()=>consultarNota(1,18)}/>
                  </Tabs>
              </AppBar>
            </AccordionDetails>
          </Accordion>

          <Accordion expanded={expanded === 'panel5'} onChange={handleChangeAcc('panel5')}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Tab className="Mui-selected" style={{backgroundColor: '#f8a700', color: 'white', minWidth: '-webkit-fill-available'}} label="Capacitación Sistema de Riesgos del Trabajo"/>
          </AccordionSummary>
          <AccordionDetails>
            <AppBar  position="static"  style={{'height': 'max-content',  width: 'auto',backgroundColor: 'white', color: 'grey', 'display': 'flex', flexFlow: 'column'}}>
                <Tabs 
                      className={classesTab.root}
                      value={value-20}
                      onChange={handleChange}
                      TabIndicatorProps={{style: {background:'#83BC00', height:'5px'}}}
                      style={{backgroundColor: 'white', color: 'grey', 'display': 'flex', flexFlow: 'column'}}
                    >
                    <Tab className={classesTab.root}  label="Mensaje de Bienvenida" onClick={()=>consultarNota(0,20)}/>
                    <Tab className={classesTab.root} label="Alcance del Curso" onClick={()=>consultarNota(0,21)}/>
                </Tabs>
              </AppBar>
            </AccordionDetails>
          </Accordion>
          

          <Accordion expanded={expanded === 'panel6'} onChange={handleChangeAcc('panel6')}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Tab className="Mui-selected" style={{backgroundColor: '#f8a700', color: 'white', minWidth: '-webkit-fill-available'}} label="Parte 1: Sistema de Riesgos del Trabajo" />
          </AccordionSummary>
          <AccordionDetails>
            <AppBar  position="static"  style={{'height': 'max-content',  width: 'auto',backgroundColor: 'white', color: 'grey', 'display': 'flex', flexFlow: 'column'}}>
                <Tabs 
                      className={classesTab.root}
                      value={value-23}
                      onChange={handleChange}
                      TabIndicatorProps={{style: {background:'#83BC00', height:'5px'}}}
                      style={{backgroundColor: 'white', color: 'grey', 'display': 'flex', flexFlow: 'column'}}
                    >
                    <Tab className={classesTab.root} label="Sistema de Riesgo del Trabajo" onClick={()=>consultarNota(0,23)}/>
                    <Tab className={classesTab.root} label="Póliza Digital" onClick={()=>consultarNota(0,24)}/>
                    <Tab className={classesTab.root} label="Evaluacion Parte 1" onClick={()=>consultarNota(15,25)}/>
                </Tabs>
              </AppBar>
            </AccordionDetails>
          </Accordion>


          <Accordion expanded={expanded === 'panel7'} onChange={handleChangeAcc('panel7')}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Tab className="Mui-selected" style={{backgroundColor: '#f8a700', color: 'white', minWidth: '-webkit-fill-available'}} label="Parte 2: Siniestros" />
          </AccordionSummary>
          <AccordionDetails>
            <AppBar  position="static"  style={{'height': 'max-content',  width: 'auto',backgroundColor: 'white', color: 'grey', 'display': 'flex', flexFlow: 'column'}}>
              <Tabs 
                    className={classesTab.root}
                    value={value-27}
                    onChange={handleChange}
                    TabIndicatorProps={{style: {background:'#83BC00', height:'5px'}}}
                    style={{backgroundColor: 'white', color: 'grey', 'display': 'flex', flexFlow: 'column'}}
                  >
              <Tab className={classesTab.root} label="Denuncias de Contingencias" onClick={()=>consultarNota(0,27)}/>
              <Tab disabled={accesoModuloRiesgoTrabajo2} className={classesTab.root} label="Evaluacion Parte 2" onClick={()=>consultarNota(16,28)}/>
              </Tabs>
              </AppBar>
            </AccordionDetails>
          </Accordion>
            
          
          <Accordion expanded={expanded === 'panel8'} onChange={handleChangeAcc('panel8')}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Tab className="Mui-selected" style={{backgroundColor: '#f8a700', color: 'white', minWidth: '-webkit-fill-available'}} label="Parte 3: Prestaciones"/>
          </AccordionSummary>
         
            <AccordionDetails>
              <AppBar  position="static"  style={{'height': 'max-content',  width: 'auto',backgroundColor: 'white', color: 'grey', 'display': 'flex', flexFlow: 'column'}}>
                <Tabs 
                      className={classesTab.root}
                      value={value-30}
                      onChange={handleChange}
                      TabIndicatorProps={{style: {background:'#83BC00', height:'5px'}}}
                      style={{backgroundColor: 'white', color: 'grey', 'display': 'flex', flexFlow: 'column'}}>           
                  <Tab className={classesTab.root} label="Incapacidad Laboral Permanente" onClick={()=>consultarNota(0,30)}/>
                  <Tab className={classesTab.root} label="Prestaciones Dinerarias" onClick={()=>consultarNota(0,31)}/>
                  <Tab className={classesTab.root} label="Prestaciones en Especie" onClick={()=>consultarNota(0,32)}/>
                  <Tab  disabled={accesoModuloRiesgoTrabajo3} className={classesTab.root} label="Evaluacion Parte 3" onClick={()=>consultarNota(17,33)}/>
                </Tabs>
              </AppBar>
            </AccordionDetails>
          </Accordion>

          <Accordion expanded={expanded === 'panel9'} onChange={handleChangeAcc('panel9')}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                  <Tab className="Mui-selected" style={{backgroundColor: '#f8a700', color: 'white', minWidth: '-webkit-fill-available'}} label="Certificado de Aprobación"/>
              </AccordionSummary>
              <AccordionDetails>
                <AppBar  position="static"  style={{'height': 'max-content',  width: 'auto',backgroundColor: 'white', color: 'grey', 'display': 'flex', flexFlow: 'column'}}>
                  <Tabs 
                        className={classesTab.root}
                        value={value-34}
                        onChange={handleChange}
                        TabIndicatorProps={{style: {background:'#83BC00', height:'5px'}}}
                        style={{backgroundColor: 'white', color: 'grey', 'display': 'flex', flexFlow: 'column'}}>           
                    <Tab  disabled={!verCertificado} className={classesTab.root} label="Certificado de Aprobación" onClick={()=>consultarNota(17,34)}/>
                  </Tabs>
                </AppBar>
              </AccordionDetails>

          </Accordion>
         
          {userTipo2 === "E" ?
          <Tab className="Mui-selected" style={{backgroundColor: '#f8a700', color: 'white', minWidth: '-webkit-fill-available'}} label="Declaracion Jurada Empleador" onClick={()=>consultarNota(0,35)}/>
            :null}

      </AppBar>

      <div>
      <SwipeableViews
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        <TabPanel value={value} index={0} dir={theme.direction}>

        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>

        </TabPanel>

        <TabPanel value={value} index={2} dir={theme.direction}>
                <ul className="list-group">
                {state.Mod1_Cap1.map(obj => (
                    <li 
                    key={obj.Desc}
                    className="list-item-descargas"
                    >
                    {obj.Desc}
                      <a href="#">
                      <Link to={"Modulo1/"+obj.File} target="_blank" download>
                        <Icon style={{float: "right"}} fill="#F8A700" width={25} />
                      </Link>
                      </a>
                    </li>
                ))}
                </ul>

                <div style={{marginTop: '5%', textAlign: 'center'}}>
                    <YoutubePlayer
                      src="https://youtu.be/31tYZPOBq4Y"
                      width={800}
                      height={600}
                    /> 
                  </div>

                
                  {(userTipo2 === "T" && nota2 < 6) ? 
                  <Capacitacion_Evaluacion IdEval={4} CUITEmpre={userCUIT} Id={userId2} EstablecimientoId={establecimId}/>
                  : (userTipo2 == "T" ?? <div>Evaluación realizada: Calificación ({nota2}) </div> )}

            
        </TabPanel>

        <TabPanel value={value} index={3} dir={theme.direction}>
                <ul className="list-group">
                {state.Mod1_Cap2.map(obj => (
                    <li 
                    key={obj.Desc}
                    className="list-item-descargas"
                    >
                    {obj.Desc}
                      <a href="#">
                      <Link to={"Modulo1/"+obj.File} target="_blank" download>
                        <Icon style={{float: "right"}} fill="#F8A700" width={25} />
                      </Link>
                      </a>
                    </li>
                ))}
                </ul>

                <div style={{marginTop: '5%', textAlign: 'center'}}>
                    <YoutubePlayer
                      src="https://youtu.be/0MXU24NPOqM"
                      width={800}
                      height={600}
                    /> 
                  </div>

                
                  {(userTipo2 === "T" && nota2 < 6) ? 
                  <Capacitacion_Evaluacion IdEval={7} CUITEmpre={userCUIT} Id={userId2} EstablecimientoId={establecimId}/>
                   : (userTipo2 == "T" ?? <div>Evaluación realizada: Calificación ({nota2}) </div> )}
        </TabPanel>

        <TabPanel value={value} index={4} dir={theme.direction}>
                <ul className="list-group">
                {state.Mod1_Cap3.map(obj => (
                    <li 
                    key={obj.Desc}
                    className="list-item-descargas"
                    >
                    {obj.Desc}
                      <a href="#">
                      <Link to={"Modulo1/"+obj.File} target="_blank" download>
                        <Icon style={{float: "right"}} fill="#F8A700" width={25} />
                      </Link>
                      </a>
                    </li>
                ))}
                </ul>

                <div style={{marginTop: '5%', textAlign: 'center'}}>
                    <YoutubePlayer
                      src="https://youtu.be/FCkN_2xkWnA"
                      width={800}
                      height={600}
                    /> 
                  </div>

                
                  {(userTipo2 === "T" && nota2 < 6) ? 
                  <Capacitacion_Evaluacion IdEval={9} CUITEmpre={userCUIT} Id={userId2} EstablecimientoId={establecimId}/>
                   : (userTipo2 == "T" ?? <div>Evaluación realizada: Calificación ({nota2}) </div> )}
        </TabPanel>

        <TabPanel value={value} index={5} dir={theme.direction}>
                <ul className="list-group">
                {state.Mod1_Cap4.map(obj => (
                    <li 
                    key={obj.Desc}
                    className="list-item-descargas"
                    >
                    {obj.Desc}
                      <a href="#">
                      <Link to={"Modulo1/"+obj.File} target="_blank" download>
                        <Icon style={{float: "right"}} fill="#F8A700" width={25} />
                      </Link>
                      </a>
                    </li>
                ))}
                </ul>

                <div style={{marginTop: '5%', textAlign: 'center'}}>
                    <YoutubePlayer
                      src="https://youtu.be/8yQDpq_Yl9Y"
                      width={800}
                      height={600}
                    /> 
                </div>
                
                {(userTipo2 === "T" && nota2 < 6) ? 
                <Capacitacion_Evaluacion IdEval={12} CUITEmpre={userCUIT} Id={userId2} EstablecimientoId={establecimId}/>
                 : (userTipo2 == "T" ?? <div>Evaluación realizada: Calificación ({nota2}) </div> )}
        </TabPanel>

        <TabPanel value={value} index={6} dir={theme.direction}>
        </TabPanel>

        <TabPanel value={value} index={7} dir={theme.direction}>
                <ul className="list-group"> 
                {state.Mod2_Cap1.map(obj => (
                    <li 
                    key={obj.Desc}
                    className="list-item-descargas"
                    >
                      {obj.Desc}
                      <a href="#">
                      <Link to={"Modulo2/"+obj.File} target="_blank" download>
                        <Icon style={{float: "right"}} fill="#F8A700" width={25} />
                      </Link>
                      </a>
                    </li>
                ))}
                </ul>
                  <div style={{marginTop: '5%', textAlign: 'center'}}>
                    <YoutubePlayer
                      src="https://youtu.be/5nVACv-X8V8"
                      width={800}
                      height={600}
                    /> 
                  </div>

                  
                  {(userTipo2 === "T" && nota2 < 6) ? 
                  <Capacitacion_Evaluacion IdEval={1} CUITEmpre={userCUIT} Id={userId2} EstablecimientoId={establecimId}/>
                   : (userTipo2 == "T" ?? <div>Evaluación realizada: Calificación ({nota2}) </div> )}
        </TabPanel>

        <TabPanel value={value} index={8} dir={theme.direction}>
            
                <ul className="list-group"> 
                    {state.Mod2_Cap2.map(obj => (
                    <li 
                    key={obj.Desc}
                    className="list-item-descargas"
                    >
                      {obj.Desc}
                      <a href="#">
                      <Link to={"Capacitacion/Modulo2/"+obj.File} target="_blank" download>
                        <Icon style={{float: "right"}} fill="#F8A700" width={25} />
                      </Link>
                      </a>
                    </li>
                    ))}
                </ul>
                <div style={{marginTop: '5%', textAlign: 'center'}}>
                    <YoutubePlayer
                      src="https://youtu.be/I7HO1yZ__mk"
                      width={800}
                      height={600}
                    /> 
                  </div>

                
                  {(userTipo2 === "T" && nota2 < 6) ? 
                  <Capacitacion_Evaluacion IdEval={2} CUITEmpre={userCUIT} Id={userId2} EstablecimientoId={establecimId}/>
                   : (userTipo2 == "T" ?? <div>Evaluación realizada: Calificación ({nota2}) </div> )}
                
        </TabPanel>  

        <TabPanel value={value} index={9} dir={theme.direction}>
        <ul className="list-group"> 
                {state.Mod2_Cap3.map(obj => (
                    <li 
                    key={obj.Desc}
                    className="list-item-descargas"
                    >
                      {obj.Desc}
                      <a href="#">
                      <Link to={"Modulo2/"+obj.File} target="_blank" download>
                        <Icon style={{float: "right"}} fill="#F8A700" width={25} />
                      </Link>
                      </a>
                    </li>
                ))}
                </ul>
                  <div style={{marginTop: '5%', textAlign: 'center'}}>
                    <YoutubePlayer
                      src="https://youtu.be/oC9YL4cRA30" //src="https://youtu.be/0tUgHQ-7tOY"
                      width={800}
                      height={600}
                    /> 
                  </div>

                  
                  {(userTipo2 === "T" && nota2 < 6) ? 
                  <Capacitacion_Evaluacion IdEval={5} CUITEmpre={userCUIT} Id={userId2} EstablecimientoId={establecimId}/>
                   : (userTipo2 == "T" ?? <div>Evaluación realizada: Calificación ({nota2}) </div> )}
        </TabPanel>

        <TabPanel value={value} index={10} dir={theme.direction}>
            <ul className="list-group"> 
                {state.Mod2_Cap4.map(obj => (
                    <li 
                    key={obj.Desc}
                    className="list-item-descargas"
                    >
                      {obj.Desc}
                      <a href="#">
                      <Link to={"Modulo2/"+obj.File} target="_blank" download>
                        <Icon style={{float: "right"}} fill="#F8A700" width={25} />
                      </Link>
                      </a>
                    </li>
                ))}
              </ul>
                  <div style={{marginTop: '5%', textAlign: 'center'}}>
                    <YoutubePlayer
                      src="https://youtu.be/T5MiNgehoG4"
                      width={800}
                      height={600}
                    /> 
                  </div>

                  
                  {(userTipo2 === "T" && nota2 < 6) ? 
                  <Capacitacion_Evaluacion IdEval={10} CUITEmpre={userCUIT} Id={userId2} EstablecimientoId={establecimId}/>
                   : (userTipo2 == "T" ?? <div>Evaluación realizada: Calificación ({nota2}) </div> )}
        </TabPanel>

        <TabPanel value={value} index={11} dir={theme.direction}>
        <ul className="list-group"> 
                {state.Mod2_Cap5.map(obj => (
                    <li 
                    key={obj.Desc}
                    className="list-item-descargas"
                    >
                      {obj.Desc}
                      <a href="#">
                      <Link to={"Modulo2/"+obj.File} target="_blank" download>
                        <Icon style={{float: "right"}} fill="#F8A700" width={25} />
                      </Link>
                      </a>
                    </li>
                ))}
                </ul>
                  <div style={{marginTop: '5%', textAlign: 'center'}}>
                    <YoutubePlayer
                      src="https://youtu.be/dIoeGaQTzO4"
                      width={800}
                      height={600}
                    /> 
                  </div>

                  
                  {(userTipo2 === "T" && nota2 < 6) ? 
                  <Capacitacion_Evaluacion IdEval={14} CUITEmpre={userCUIT} Id={userId2} EstablecimientoId={establecimId}/>
                   : (userTipo2 == "T" ?? <div>Evaluación realizada: Calificación ({nota2}) </div> )}
        </TabPanel>           

        <TabPanel value={value} index={12} dir={theme.direction}>
        </TabPanel>  

        <TabPanel value={value} index={13} dir={theme.direction}>
                <ul className="list-group"> 
                {state.Mod3_Cap1.map(obj => (
                    <li 
                    key={obj.Desc}
                    className="list-item-descargas"
                    >
                      {obj.Desc}
                      <a href="#">
                      <Link to={"Download/PRESTADORES/"+obj.File} target="_blank" download>
                        <Icon style={{float: "right"}} fill="#F8A700" width={25} />
                      </Link>
                      </a>
                    </li>
                ))}
                </ul>
                <div style={{marginTop: '5%', textAlign: 'center'}}>
                    <YoutubePlayer
                      src="https://youtu.be/o73fvnwL9ow"
                      width={800}
                      height={600}
                    /> 
                </div>

                {(userTipo2 === "T" && nota2 < 6) ? 
                <Capacitacion_Evaluacion IdEval={6} CUITEmpre={userCUIT} Id={userId2} EstablecimientoId={establecimId}/>
                 : (userTipo2 == "T" ?? <div>Evaluación realizada: Calificación ({nota2}) </div> )}
        </TabPanel>  

        <TabPanel value={value} index={14} dir={theme.direction}>
                <ul className="list-group"> 
                {state.Mod3_Cap2.map(obj => (
                    <li 
                    key={obj.Desc}
                    className="list-item-descargas"
                    >
                      {obj.Desc}
                      <a href="#">
                      <Link to={"Download/PRESTADORES/"+obj.File} target="_blank" download>
                        <Icon style={{float: "right"}} fill="#F8A700" width={25} />
                      </Link>
                      </a>
                    </li>
                ))}
                </ul>
                <div style={{marginTop: '5%', textAlign: 'center'}}>
                    <YoutubePlayer
                      src="https://youtu.be/QJtOJ-uIrjM"
                      width={800}
                      height={600}
                    />
                </div>

                {(userTipo2 === "T" && nota2 < 6) ? 
                <Capacitacion_Evaluacion IdEval={8} CUITEmpre={userCUIT} Id={userId2} EstablecimientoId={establecimId}/>
                 : (userTipo2 == "T" ?? <div>Evaluación realizada: Calificación ({nota2}) </div> )}
        </TabPanel> 

        <TabPanel value={value} index={15} dir={theme.direction}>
        
        </TabPanel>  

        <TabPanel value={value} index={16} dir={theme.direction}>
                <ul className="list-group"> 
                {state.Mod4_Cap1.map(obj => (
                    <li 
                    key={obj.Desc}
                    className="list-item-descargas"
                    >
                      {obj.Desc}
                      <a href="#">
                        <Link to={"Download/PRESTADORES/"+obj.File} target="_blank" download>
                            <Icon style={{float: "right"}} fill="#F8A700" width={25} />
                        </Link>
                      </a>
                    </li>
                ))}
                </ul>

                  <div style={{marginTop: '5%', textAlign: 'center'}}>
                    <YoutubePlayer
                      src="https://youtu.be/X7dlGA3Ab-Q"
                      width={800}
                      height={600}
                    /> 
                  </div>
                  {(userTipo2 === "T" && nota2 < 6) ? 
                  <Capacitacion_Evaluacion IdEval={3} CUITEmpre={userCUIT} Id={userId2} EstablecimientoId={establecimId}/>
                   : (userTipo2 == "T" ?? <div>Evaluación realizada: Calificación ({nota2}) </div> )} 
        </TabPanel>  
    
        <TabPanel value={value} index={17} dir={theme.direction}>
                <ul className="list-group"> 
                {state.Mod4_Cap1.map(obj => (
                    <li 
                    key={obj.Desc}
                    className="list-item-descargas"
                    >
                      {obj.Desc}
                      <a href="#">
                        <Link to={"Download/PRESTADORES/"+obj.File} target="_blank" download>
                            <Icon style={{float: "right"}} fill="#F8A700" width={25} />
                        </Link>
                      </a>
                    </li>
                ))}
                </ul>

                  <div style={{marginTop: '5%', textAlign: 'center'}}>
                    <YoutubePlayer
                      src="https://www.youtube.com/watch?v=TgBa0MO1uj0"
                      width={800}
                      height={600}
                    /> 
                  </div>

                  {(userTipo2 === "T" && nota2 < 6) ? 
                  <Capacitacion_Evaluacion IdEval={11} CUITEmpre={userCUIT} Id={userId2} EstablecimientoId={establecimId}/>
                   : (userTipo2 == "T" ?? <div>Evaluación realizada: Calificación ({nota2}) </div> )} 
        </TabPanel>  

        <TabPanel value={value} index={18} dir={theme.direction}>
                <ul className="list-group"> 
                {state.Mod4_Cap1.map(obj => (
                    <li 
                    key={obj.Desc}
                    className="list-item-descargas"
                    >
                      {obj.Desc}
                      <a href="#">
                        <Link to={"Download/PRESTADORES/"+obj.File} target="_blank" download>
                            <Icon style={{float: "right"}} fill="#F8A700" width={25} />
                        </Link>
                      </a>
                    </li>
                ))}
                </ul>

                  <div style={{marginTop: '5%', textAlign: 'center'}}>
                    <YoutubePlayer
                      src="https://www.youtube.com/watch?v=pGoAlbFulrM"
                      width={800}
                      height={600}
                    /> 
                  </div>

                  {(userTipo2 === "T" && nota2 < 6) ? 
                  <Capacitacion_Evaluacion IdEval={13} CUITEmpre={userCUIT} Id={userId2} EstablecimientoId={establecimId}/>
                   : (userTipo2 == "T" ?? <div>Evaluación realizada: Calificación ({nota2}) </div> )} 
        </TabPanel>

        {/* RIESGOS DEL TRABAJO*/}
        <TabPanel value={value} index={19} dir={theme.direction}>
           
        </TabPanel>

        <TabPanel value={value} index={20} dir={theme.direction}>
            Compañeros/as le damos la bienvenida al curso de capacitación del Sistema de Riesgos del Trabajo. 
            <div style={{marginTop: '5%', textAlign: 'center'}}>
              <YoutubePlayer
                src="https://youtu.be/K5HykPQbz44"
                width={800}
                height={600}
              /> 
            </div>
            <div style={{marginTop: '5%', textAlign: 'center'}}>
                <YoutubePlayer
                  src="https://youtu.be/k6IRN6_FZSE"
                  width={800}
                  height={600}
                /> 
              </div>
        </TabPanel>
        <TabPanel value={value} index={21} dir={theme.direction}>
              Compañeros/as le damos la bienvenida al curso de capacitación del Sistema de Riesgos del Trabajo y les comentamos el alcance del mismo. 
               <div style={{marginTop: '5%', textAlign: 'center'}}>
                <YoutubePlayer
                  src="https://youtu.be/U4oVwTRnp90"
                  width={800}
                  height={600}
                /> 
              </div>
              <div style={{marginTop: '5%', textAlign: 'center'}}>
                <YoutubePlayer
                  src="https://youtu.be/KTqFXCeFhyQ"
                  width={800}
                  height={600}
                /> 
              </div>
        </TabPanel>

        <TabPanel value={value} index={22} dir={theme.direction}>
        </TabPanel>

        <TabPanel value={value} index={23} dir={theme.direction}>

            <div style={{marginTop: '5%', textAlign: 'center'}}>
              <YoutubePlayer
                  src="https://youtu.be/WHI2FKs4gbQ"
                  width={800}
                  height={600}
                /> 
            </div>
            <div style={{marginTop: '5%', textAlign: 'center'}}>
              <YoutubePlayer
                  src="https://youtu.be/y-rRwd6g6AA"
                  width={800}
                  height={600}
                /> 
            </div>

        </TabPanel>

        <TabPanel value={value} index={24} dir={theme.direction}>
            <div style={{marginTop: '5%', textAlign: 'center'}}>
              <YoutubePlayer
                src="https://youtu.be/-ns8FJyJqyM"
                width={800}
                height={600}
              /> 
            </div>

             <div style={{marginTop: '5%', textAlign: 'center'}}>
              <YoutubePlayer
                src="https://youtu.be/XUT6y_AhEk8"
                width={800}
                height={600}
              /> 
            </div>
        </TabPanel>

        <TabPanel value={value} index={25} dir={theme.direction}>
              {(userTipo2 === "T" && notaDelUsuario < 6) ? 
                    <Capacitacion_Evaluacion reset={reset} IdEval={15} CUITEmpre={userCUIT} Id={userId2} EstablecimientoId={establecimId}/>
                      : (userTipo2 == "T" ? <div>PARTE 1 - Evaluación realizada: Calificación ({notaDelUsuario}) </div>  : '')}
        </TabPanel>

        {/*PARTE 2*/}
        <TabPanel value={value} index={26} dir={theme.direction}>

        </TabPanel>

        <TabPanel value={value} index={27} dir={theme.direction}>
              <div style={{marginTop: '5%', textAlign: 'center'}}>
                <YoutubePlayer
                  src="https://youtu.be/A3XzUHof7o4"
                  width={800}
                  height={600}
                /> 
              </div>
              <div style={{marginTop: '5%', textAlign: 'center'}}>
                <YoutubePlayer
                  src="https://youtu.be/RyOyVnEHfYs"
                  width={800}
                  height={600}
                /> 
              </div>
              
              <p className="container denuncias">
                  <img src={Denuncia}/>    
                  
              </p>
             <ul className="list-group"> 
                  <li className="list-item-descargas">
                    Denuncia de Accidente Laboral
                    <a href="#">
                    <Link to={"Download/PRESTACIONES/Formulario Denuncia de Accidente Laboral.pdf"} target="_blank" download>
                          
                      <Icon style={{float: "right"}} fill="#F8A700" width={25} />
                    </Link>
                    </a>
                  </li>

                  <li className="list-item-descargas">
                    Denuncia de Enfermedad Profesional
                    <a href="#">
                    <Link to={"Download/PRESTACIONES/Formulario Denuncia de Enfermedad Profesional.pdf"} target="_blank" download>
                          
                      <Icon style={{float: "right"}} fill="#F8A700" width={25} />
                    </Link>
                    </a>
                  </li>
              </ul>
        </TabPanel>

        <TabPanel value={value} index={28} dir={theme.direction}>
              {(userTipo2 === "T" && notaDelUsuario < 6) ? 
              <Capacitacion_Evaluacion reset={reset} IdEval={16} CUITEmpre={userCUIT} Id={userId2} EstablecimientoId={establecimId}/>
                : (userTipo2 == "T" ? <div>PARTE 2 - Evaluación realizada: Calificación ({notaDelUsuario}) </div> : '')} 
        </TabPanel>


        <TabPanel value={value} index={29} dir={theme.direction}>
          
        </TabPanel>

        <TabPanel value={value} index={30} dir={theme.direction}>
            <div style={{marginTop: '5%', textAlign: 'center'}}>
              <YoutubePlayer
                src="https://youtu.be/pS_AkANfJQ4"
                width={800}
                height={600}
              /> 
            </div>
        </TabPanel>

        <TabPanel value={value} index={31} dir={theme.direction}>
            <div style={{marginTop: '5%', textAlign: 'center'}}>
              <YoutubePlayer
                src="https://youtu.be/DeHFcsFW74M"
                width={800}
                height={600}
              /> 
            </div>
        </TabPanel>
        <TabPanel value={value} index={32} dir={theme.direction}>
            <div style={{marginTop: '5%', textAlign: 'center'}}>
              <YoutubePlayer
                src="https://youtu.be/tvDUH7975O4"
                width={800}
                height={600}
              /> 
            </div>
            <div style={{marginTop: '5%', textAlign: 'center'}}>
              <YoutubePlayer
                src="https://youtu.be/nmKZelW3d0M"
                width={800}
                height={600}
              /> 
            </div>
        </TabPanel>

        <TabPanel value={value} index={33} dir={theme.direction}>
              {(userTipo2 === "T" && notaDelUsuario < 6) ? 
              <Capacitacion_Evaluacion IdEval={17} CUITEmpre={userCUIT} Id={userId2} EstablecimientoId={establecimId}/>
                : (userTipo2 == "T" ? <div>PARTE 3 - Evaluación realizada: Calificación ({notaDelUsuario}) </div> : '' )} 
        </TabPanel>

        
        <TabPanel value={value} index={34} dir={theme.direction}>
              {/*CERTIFICADO CONDICIONAL EVALUACION 3*/}

              <Button type="submit" variant="contained" color="primary" disabled={1 > 0 ? false:true} onClick={() => handleAbrirPDF()}>
                  Imprimir Certificado de Aprobación
              </Button>

              <div style={{marginTop: '5%', textAlign: 'center'}}>
              ¡Se parte de la Art  Mutual Rural!
                <YoutubePlayer
                  src="https://youtu.be/t3-N8FwkloY"
                  width={800}
                  height={600}
                /> 
              </div>

              <div style={{marginTop: '5%', textAlign: 'center'}}>
              Te dejamos los principales conceptos antes de finalizar
                <YoutubePlayer
                  src="https://youtu.be/5lBxwXR9LpQ"
                  width={800}
                  height={600}
                /> 
              </div>

              {abrirPDF ? <Capacitacion_Certificado_PDF_Ventana
                modalPDFIsOpen={abrirPDF}        
                handleAbrirPDF={handleAbrirPDF}
                nombre={props.nombre}/> : null}    

        </TabPanel>

        <TabPanel value={value} index={35} dir={theme.direction}>
              <Capacitacion_DDJJ CUIT={userCUIT}/>  
        </TabPanel>
      </SwipeableViews>
      </div>
      
    </div>
     
    </div>
  );
}